import HttpClient from "@lib/http-client";

/**
 * @memberof Services
 */
class UserPreferencesService extends HttpClient {
  /**
   * Reads the current user's preferences for a given scope.
   *
   * @param {string} scopeKey - Preference scope identifier
   * @param {AbortSignal} [signal] - Request cancellation signal
   */
  get(scopeKey, signal) {
    return this.http.get(
      `/user/me/preferences/${encodeURIComponent(scopeKey)}`,
      { signal }
    );
  }

  /**
   * Replaces the current user's preferences for a given scope.
   *
   * @param {string} scopeKey - Preference scope identifier
   * @param {object} prefs - Preference payload to persist
   */
  put(scopeKey, prefs) {
    return this.http.put(
      `/user/me/preferences/${encodeURIComponent(scopeKey)}`,
      prefs
    );
  }
}

export default UserPreferencesService;
